/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .directive('accBreadcrumbs', ['headerService', 'SearchService', 'template', function(headerService, SearchService, template) {

    var
        SPINNER_WIDTH_PX = 32,
        TRUNCATED_ELEMENT_PX = 42,
        MIN_TRUNCATE_WIDTH = 48;

    return {
        scope: {},
        replace: true,
        templateUrl: template('_breadcrumbs'),
        controller: ['$scope', function($scope) {
            $scope.header = headerService;
            $scope.searchState = SearchService.searchState;
            $scope.resetSearch = function() { SearchService.resetSearch(); };
        }],
        link: function($scope, $element) {
            var breadcrumbs;
    
            setToInitialState();

            $scope.$on('windowResize', function() {
                $scope.breadcrumbs.usableSpace = $element.innerWidth();
                restoreLastElement();
                recalculateWidth();
            });

            $scope.$watch('header.getBreadcrumbs()', function(items){
                breadcrumbs = items;
                setToInitialState();
            });
            
            $scope.$watchCollection('breadcrumbs.widths', function(widths) {
                if (!widths) return;
    
                recalculateWidth();
            });
    
            function setToInitialState() {
                $scope.breadcrumbs = {
                    usableSpace: $element.innerWidth(),
                    widths: [],
                    sumWidth: SPINNER_WIDTH_PX
                };
            }
    
            function recalculateWidth() {
                $scope.breadcrumbs.sumWidth = SPINNER_WIDTH_PX;
        
                for (var i = 0; i < $scope.breadcrumbs.widths.length; i++) {
                    breadcrumbs[i].truncated = false;
                    $scope.breadcrumbs.sumWidth += $scope.breadcrumbs.widths[i];
                }
    
                if (isOverflowing()) {
                    truncateBreadcrumbs();
                }
            }
    
            function isOverflowing() {
                return breadcrumbs.length > 1 && $scope.breadcrumbs.sumWidth >= $scope.breadcrumbs.usableSpace;
            }
            
            function truncateBreadcrumbs() {
                var i = 1; // skip the first element
                
                while (isOverflowing()) {
                    breadcrumbs[i].truncated = true;
                    if (breadcrumbs[i].current) { // last element
                        truncateLastElement();
                        break;
                    } else {
                        $scope.breadcrumbs.sumWidth = $scope.breadcrumbs.sumWidth - $scope.breadcrumbs.widths[i] + TRUNCATED_ELEMENT_PX;
                        i++;
                    }
                }
            }
            
            function getLastElement() {
                return $element.find('span.current > a');
            }
            
            function truncateLastElement() {
                var
                    lastElementWidth = $scope.breadcrumbs.widths[$scope.breadcrumbs.widths.length - 1],
                    availableSpace = $scope.breadcrumbs.usableSpace - ($scope.breadcrumbs.sumWidth - lastElementWidth + SPINNER_WIDTH_PX);
    
                // do not try to truncate to less than 48 px
                // 48px gives us '...' and 3/4 more symbols
                availableSpace = Math.max(availableSpace, MIN_TRUNCATE_WIDTH);
                
                getLastElement().oldTruncate({
                    width: availableSpace,
                    token: '&hellip;',
                    side: 'center',
                    multiline: false,
                    addtitle: false,
                    addclass: 'truncated'
                });
            }
            
            function restoreLastElement() {
                if (getLastElement().hasClass('truncated')) {
                    getLastElement().text(breadcrumbs[breadcrumbs.length - 1].name);
                }
            }
        }
    }
}]);